import { PhoneIcon } from '@heroicons/react/20/solid';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

import { get as getConfig } from '@/helpers/config';
import logo from '@/images/logo_felice_headwear.png';

export function Footer() {
    const [
        t,
    ] = useTranslation('pages');
    const config = getConfig();

    return (
        <footer className='mx-4 border-t border-border bg-secondary mt-auto'>
            <div className='mx-auto px-6 py-12'>
                <div className='grid grid-cols-1 md:grid-cols-3 gap-8'>
                    {/* Brand */}
                    <div>
                        <img alt='Félice Headwear' className='h-10 object-contain mb-4' src={ logo } />
                        <p className='text-sm text-muted-foreground'>
                            {t('Specialized headwear for oncology patients. Comfort, style, and care in every piece.')}
                        </p>
                    </div>

                    {/* More Information */}
                    <div>
                        <h4 className='font-medium text-foreground mb-4'>{t('More Information')}</h4>
                        <ul className='space-y-2'>
                            <li>
                                <NavLink className='text-sm text-muted-foreground hover:text-primary transition-colors' to='/about'>
                                    {t('About Us')}
                                </NavLink>
                            </li>
                            <li>
                                <NavLink className='text-sm text-muted-foreground hover:text-primary transition-colors' to='/contact'>
                                    {t('Contact us')}
                                </NavLink>
                            </li>
                        </ul>
                    </div>

                    {/* Contact */}
                    <div>
                        <h4 className='font-medium text-foreground mb-4'>{t('Need Help?')}</h4>
                        <div className='space-y-3'>
                            <a
                                className='flex items-center gap-3 text-primary hover:text-primary/80 transition-colors'
                                href='tel:+34652391042'
                            >
                                <PhoneIcon className='h-5 w-5' />
                                <span className='font-medium'>+34 652 391 042</span>
                            </a>
                            <p className='text-sm text-muted-foreground'>
                                {t('Mon - Fri: 10:00 - 16:00')}
                            </p>
                            <p className='text-sm text-muted-foreground'>
                                Edificio BMC<br/>
                                Ronda dels Maiols, 1, Of. 108B<br/>
                                08192-Sant Quirze del Vallés (Barcelona)
                            </p>
                        </div>
                    </div>
                </div>

                <div className='border-t border-border mt-8 pt-8 flex items-center justify-between'>
                    <p className='text-sm text-muted-foreground'>
                        © {new Date().getFullYear()} Félice Headwear. All rights reserved.
                    </p>
                    <span className='text-xs font-mono text-muted-foreground border border-border rounded px-1.5 py-0.5 bg-muted/50'>Build {config.version}</span>
                </div>
            </div>
        </footer>
    );
}
